import diagnostics from "../../Assets/diagnostics.png";
import precisionimg from "../../Assets/precision-img.png";
import edge1 from "../../Assets/edge1.png";
import relaximg from "../../Assets/relax-img.png";
import doctorconcimg from "../../Assets/doc-consultation-img.png";
import nomoretraffic from "../../Assets/nomoretraffic.png";
import cause1 from "../../Assets/cause1.png";
import cause2 from "../../Assets/cause2.png";
import cause3 from "../../Assets/cause3.png";
import cause4 from "../../Assets/cause4.png";
import cause5 from "../../Assets/cause5.png";
import cause6 from "../../Assets/cause6.png";
import cause7 from "../../Assets/cause7.png";
import cause8 from "../../Assets/cause8.png";
import cause9 from "../../Assets/cause9.png";
import cause10 from "../../Assets/cause10.png";
import cause11 from "../../Assets/cause11.png";
import cause12 from "../../Assets/cause12.png";
import cause13 from "../../Assets/cause13.png";
import assistance1 from "../../Assets/assistance1.png";
import assistance2 from "../../Assets/assistance2.png";
import assistance3 from "../../Assets/assistance3.png";
import assistance4 from "../../Assets/assistance4.png";
import assistance5 from "../../Assets/assistance5.png";
import unmached1 from "../../Assets/unmached1.png";
import unmached2 from "../../Assets/unmached2.png";
import unmached3 from "../../Assets/unmached3.png";
import unmached4 from "../../Assets/unmached4.png";
import prem from "../../Assets/prem.png"
import harshita from "../../Assets/harshita.png"
import kartik from "../../Assets/kartik.png"


export const serviceShowcaseData = [
  {
    imgSrc: doctorconcimg,
    title: `Your Health Matters\n Wherever You Are`,
    buttonText: "Book Now",
    onButtonClick: () => console.log("Button Clicked"),
  },
];

export const chooseexcellence_data = {
  title: `No More Traffic`,
  subheading: `No More Waiting Rooms`,
  para1: `Just personalized care in the comfort of your own home. Our team understands that every patient is unique, which is why we tailor our consultations to your specific needs and schedule. From routine check-ups to urgent medical attention, we've got you covered`,
  image: nomoretraffic,
};

export const causesubheading = `Scope Of Expertise We Offer`;
export const causeheading = `Healing Begins When You Treat The Root Cause`;
export const causeServices = {
  o1: { title: "Internal Medicine", img: cause1 },
  o2: { title: "Pediatrics", img: cause2 },
  o3: { title: "Geriatrics", img: cause3 },
  o4: { title: "Obstetrics", img: cause4 },
  o5: { title: "Gynecology", img: cause5 },
  o6: { title: "Psychiatry", img: cause6 },
  o7: { title: "Dermatology", img: cause7 },
  o8: { title: "Orthopedics", img: cause8 },
  o9: { title: "Cardiology", img: cause9 },
  o10: { title: "Ophthalmology", img: cause10 },
  o11: { title: "Gastroenterology", img: cause11 },
  o12: { title: "ENT", img: cause12 },
  o13: { title: "Endocrinology", img: cause13 },
};

export const assistanceheading = `Who Requires Our Assistance`;

export const assistanceservices = {
  CriticallyIll: { title: "Critically Ill", img: assistance1 },
  PostSurgery: { title: "Post Surgery", img: assistance2 },
  HealthScreening: { title: "Health Screening", img: assistance3 },
  PalliativeCare: { title: "Palliative Care", img: assistance4 },
  BedriddenPatients: { title: "Bedridden Patients", img: assistance5 },
};

export const relax_data = {
  title: `Sit Back & Relax`,
  subheading: `We’ll Be Right There`,
  para1: `Take the hassle out of healthcare with our convenient home doctor consultation service. We understand that visiting a clinic or hospital can be stressful and time-consuming, especially when you're not feeling well. That's why we bring quality medical care directly to your doorstep.`,
  image: relaximg,
};

export const unmachedheading = `Unmatched Medical Excellence`;
export const unmachedservices = {
  o1: { title: "Expert Physicians", img: unmached1 },
  o2: { title: "Patient-Centered", img: unmached2 },
  o3: { title: "Interdisciplinary Care", img: unmached3 },
  o4: { title: "Continuity Of Care", img: unmached4 },
};
//testimonial data

export const doc_conc_testimonials = [
  {
    title: `Discover Why Everyone's Talking About Us`,
    desc: `I've been using the wihan home doctor consultation service for my
elderly parents, who have trouble getting around. The doctors are 
always kind, patient, and thorough during their visits. It's been a
game-changer for our family.`,
    userimg: prem,
    username: "Prem Kumar",
  },
  {
    title: `Discover Why Everyone's Talking About Us`,
    desc: `I recently had a baby and the wihan home doctor consultation service
has been a godsend. Instead of dragging my newborn to the clinic for
check-ups, the doctor comes to us. It's been invaluable in those early
weeks of motherhood`,
    userimg: harshita,
    username: "Harshitha pabba",
  },
  {
    title: `Discover Why Everyone's Talking About Us`,
    desc: `My grandmother has Alzheimer's and going to the clinic is overwhelming
for her. With the wihan home doctor consultation service, she feels more
comfortable and at ease receiving medical care at home. It's been a
huge relief for our family`,
    userimg: kartik,
    username: "Karthik Reddy",
  },
];
